import { render, staticRenderFns } from "./block-show.vue?vue&type=template&id=da10c128&"
import script from "./block-show.vue?vue&type=script&lang=js&"
export * from "./block-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports